import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { useMfa } from '../context/MfaContext';
import { useGetMeQuery } from '../store/redux/api/accountApi';

function MfaRouteGuard({ children }) {
  const { isAuthenticated, authLoading, authState } = useContext(AuthContext);
  const { mfaVerified } = useMfa();
  const location = useLocation();
  const { data: me, isLoading } = useGetMeQuery();

  if (authLoading || isLoading) {
    return children;
  }

  if (!isAuthenticated()) {
    return <Navigate to="/login" state={{ next: location }} replace />;
  }

  const isImpersonating = sessionStorage.getItem('impersonation') === 'true';

  if (
    me?.mfa_enabled &&
    authState.account?.otp_required &&
    !mfaVerified &&
    !isImpersonating
  ) {
    return <Navigate to="/mfa" state={{ next: location }} replace />;
  }

  return children;
}

export default MfaRouteGuard;
